document.addEventListener("DOMContentLoaded", () => {
    const links = document.querySelectorAll('.drawer-menu__main_v2 .drawer-menu__link-v2 .opener')
    links.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const item = link.closest('.drawer-menu__item');
            const subLinks = item.querySelector('.drawer-menu__list--sub');
            const header = item.querySelector('.drawer-menu__link-v2')
            link.classList.toggle("visible");
            subLinks.classList.toggle("visible");
            header.classList.toggle('opened')
            if(link.getAttribute('aria-expanded') === 'true') {
                link.setAttribute('aria-expanded', 'false')
            } else {
                link.setAttribute('aria-expanded', 'true')
            }
            if(subLinks.getAttribute('aria-hidden') === 'true') {
                subLinks.setAttribute('aria-hidden', 'false')
            } else {
                subLinks.setAttribute('aria-hidden', 'true')
            }
        })
    })
})